import {Helmet} from '@dr.pogodin/react-helmet';
import {BreadcrumbType} from 'platform/components';

import {useGetRoundingDefinitionQuery} from '@dms/api/finance';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {useRequiredParams} from 'shared/web';

import {DocumentRoundingDefinitionForm} from './components/DocumentRoundingDefinitionForm';

const breadcrumbs: BreadcrumbType[] = [
  {
    label: i18n.t('page.accounting.labels.documentRoundingDefinitions'),
    href: settingsRoutes.documentRoundingDefinitions,
  },
];

export function DocumentRoundingDefinitionsEdit() {
  const {id} = useRequiredParams();
  const {data, isLoading, isError} = useGetRoundingDefinitionQuery({
    id,
  });

  const title = i18n.t('page.accounting.labels.documentRoundingDefinitions');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate
        header={{title, breadcrumbs}}
        data-testid="settings-document-rounding-definition-add-page"
        isLoading={isLoading}
        isError={isError}
      >
        <DocumentRoundingDefinitionForm roundingDefinition={data} />
      </SettingsTemplate>
    </>
  );
}
